import { DEMO_TENANT_CODE, DEMO_ENTITY } from '@paguz/contracts';
import { z } from 'zod';

/**
 * Configuración de la consola (variables `VITE_*`, públicas: nunca secretos).
 * La URL base se cambia sin recompilar el código de negocio: MSW ↔ API real.
 */
const EnvSchema = z.object({
  VITE_API_BASE_URL: z
    .string()
    .trim()
    .default('')
    .transform((value) => value.replace(/\/+$/, '')),
  /** `true`: todo por MSW · `pending`: API real + MSW solo para lo que la API aún no publica · `false`: solo API. */
  VITE_USE_MOCKS: z.enum(['true', 'false', 'pending']).default('true'),
});

const env = EnvSchema.parse({
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_USE_MOCKS: import.meta.env.VITE_USE_MOCKS,
});

export const appConfig = {
  apiBaseUrl: env.VITE_API_BASE_URL,
  useMocks: env.VITE_USE_MOCKS === 'true',
  /** MSW solo para lo que la API real aún no publica (ver `mocks/real-routes.ts`). */
  partialMocks: env.VITE_USE_MOCKS === 'pending',
  /** Tenant fijo en el demo (el selector solo lo cambia un ADMIN de plataforma). */
  tenant: { code: DEMO_TENANT_CODE, displayName: DEMO_ENTITY.name, environment: 'Demo' },
} as const;

/** URL absoluta de la API (`/v1/...`). Sin base configurada usa el origen actual. */
export function apiUrl(path: string): string {
  const base =
    appConfig.apiBaseUrl === ''
      ? typeof window === 'undefined'
        ? 'http://localhost'
        : window.location.origin
      : appConfig.apiBaseUrl;
  return `${base}${path}`;
}
